import { create } from 'zustand';
import {
  type RoomState,
  type RoomPlayer,
  initialRoomState,
  setRoomCreating,
  setRoomJoining,
  setRoomJoined,
  setRoomError,
  addPlayer,
  removePlayer,
  setPlayerReady,
  addAIPlayer,
  setRoomStarting,
  leaveRoom,
  updateRoomPlayers,
  clearRoomError,
} from '@callbridge/ui';

interface RoomActions {
  roomCreating: () => void;
  roomJoining: () => void;
  roomJoined: (
    roomCode: string,
    players: RoomPlayer[],
    maxPlayers: number,
    isPrivate: boolean,
    localPlayerId: string,
  ) => void;
  roomError: (error: string) => void;
  playerAdded: (player: RoomPlayer) => void;
  playerRemoved: (playerId: string) => void;
  playerReadyChanged: (playerId: string, isReady: boolean) => void;
  aiPlayerAdded: (playerId: string, difficulty: string) => void;
  roomStarting: () => void;
  left: () => void;
  playersUpdated: (players: RoomPlayer[]) => void;
  errorCleared: () => void;
}

export type RoomStore = RoomState & RoomActions;

export const useRoomStore = create<RoomStore>()((set) => ({
  ...initialRoomState,

  roomCreating: () => set((s) => setRoomCreating(s)),
  roomJoining: () => set((s) => setRoomJoining(s)),
  roomJoined: (code, players, max, priv, local) =>
    set((s) => setRoomJoined(s, code, players, max, priv, local)),
  roomError: (err) => set((s) => setRoomError(s, err)),
  playerAdded: (p) => set((s) => addPlayer(s, p)),
  playerRemoved: (pid) => set((s) => removePlayer(s, pid)),
  playerReadyChanged: (pid, r) => set((s) => setPlayerReady(s, pid, r)),
  aiPlayerAdded: (pid, d) => set((s) => addAIPlayer(s, pid, d)),
  roomStarting: () => set((s) => setRoomStarting(s)),
  left: () => set(() => leaveRoom()),
  playersUpdated: (p) => set((s) => updateRoomPlayers(s, p)),
  errorCleared: () => set((s) => clearRoomError(s)),
}));
